import { gql } from "@apollo/client";

import { useUpdateVisitResourceStatusMutation } from "~/graphql/__generated__/graphql";
import { useCurrentOrg } from "~/providers/GraphqlProvider";
import { nextVirtualStatusTransition, PartialVisit } from "~/utils/visitsHelper";
import { launchTelehealthCall } from "~/services/telehealthIntegration";

export const useVisitStatusAdvancer = (visit: PartialVisit) => {
  const providerId = useCurrentOrg()?.providerId;

  const nextVirtualStatus = nextVirtualStatusTransition(visit, providerId);

  const [updateResourceStatus, { loading }] = useUpdateVisitResourceStatusMutation();

  const progressVisit = async () => {
    if (!nextVirtualStatus || nextVirtualStatus?.disallowReason || !nextVirtualStatus.nextVirtualStatus) { return; }

    const newStatus = nextVirtualStatus.nextVirtualStatus.status;

    // Launch telehealth platform when joining a call
    if (newStatus === 'joined') {
      launchTelehealthCall();
    }

    await updateResourceStatus({
      variables: {
        id: nextVirtualStatus.nextVirtualStatus.id,
        visitId: visit.id,
        newStatus: newStatus,
      },
      refetchQueries: "active",
      awaitRefetchQueries: true,
    });
  };

  return {
    label: nextVirtualStatus?.label,
    disallowReason: nextVirtualStatus?.disallowReason,
    progressVisit,
    loading,
  };
};

gql(`
  mutation UpdateVisitResourceStatus($id: Int!, $visitId: Int!, $newStatus: VisitResourceVirtualProviderStatusEnum!)
  @permission(requires: useWebApp, check: [userIsProviderOnVisit])
  {
    updateVisitResourceStatus(id: $id, visitId: $visitId, virtualProviderStatus: $newStatus) {
      id
      visitId
      virtualProviderStatus
    }
  }
`);
